var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAptosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aptos_mark_WHT 1",
    clipPath: "url(#clip0_1877_17486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2641 6.81269H13.5681C13.3705 6.81269 13.1825 6.72789 13.0517 6.58029L12.3637 5.80309C12.2613 5.68709 12.1137 5.62109 11.9593 5.62109C11.8049 5.62109 11.6573 5.68749 11.5549 5.80309L10.9649 6.46989C10.7717 6.68789 10.4945 6.81309 10.2033 6.81309H0.919662C0.655262 7.56669 0.482863 8.36269 0.414062 9.18829H9.17806C9.33206 9.18829 9.47966 9.12549 9.58606 9.01429L10.4021 8.16269C10.5041 8.05629 10.6449 7.99629 10.7921 7.99629H10.8257C10.9805 7.99629 11.1277 8.06269 11.2301 8.17869L11.9177 8.95589C12.0485 9.10389 12.2365 9.18829 12.4341 9.18829H19.5877C19.5189 8.36229 19.3465 7.56629 19.0821 6.81309H15.2637L15.2641 6.81269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.71847 14.1849C5.87247 14.1849 6.02007 14.1221 6.12647 14.0109L6.94247 13.1593C7.04447 13.0529 7.18527 12.9929 7.33247 12.9929H7.36607C7.52087 12.9929 7.66807 13.0593 7.77047 13.1749L8.45807 13.9521C8.58887 14.1001 8.77687 14.1845 8.97447 14.1845H18.6689C19.0321 13.4341 19.2981 12.6289 19.4565 11.7853H10.1513C9.95367 11.7853 9.76568 11.7005 9.63488 11.5529L8.94727 10.7757C8.84487 10.6597 8.69727 10.5938 8.54287 10.5938C8.38847 10.5938 8.24087 10.6601 8.13847 10.7757L7.54847 11.4425C7.35527 11.6605 7.07807 11.7857 6.78647 11.7857H0.546875C0.705275 12.6293 0.971675 13.4345 1.33448 14.1849H5.71807H5.71847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5966 4.2182C12.7506 4.2182 12.8982 4.1554 13.0046 4.0442L13.8206 3.1926C13.9226 3.0862 14.0634 3.0262 14.2106 3.0262H14.2442C14.399 3.0262 14.5462 3.0926 14.6486 3.2086L15.3362 3.9858C15.467 4.1338 15.655 4.2182 15.8526 4.2182H17.6962C15.9406 1.8846 13.1482 0.375 10.0026 0.375C6.85699 0.375 4.06459 1.8846 2.30859 4.2182H12.5966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.89395 16.5627H6.37275C6.17515 16.5627 5.98715 16.4779 5.85635 16.3303L5.16875 15.5531C5.06635 15.4371 4.91875 15.3711 4.76435 15.3711C4.60995 15.3711 4.46235 15.4375 4.35995 15.5531L3.76995 16.2199C3.57675 16.4379 3.29955 16.5631 3.00795 16.5631H2.96875C4.72515 18.4451 7.22635 19.6231 10.0035 19.6231C12.7807 19.6231 15.2816 18.4451 17.0384 16.5631H8.89395V16.5627Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_17486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptosIcon);
export default __webpack_public_path__ + "static/media/AptosIcon.d823e3d77b5089d39ae50a95ecb7ffed.svg";
export { ForwardRef as ReactComponent };